import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin: 0;
  width: 29.1vw;
  min-height: 52.6em;
  font-size: 12px;
  background: #fffff;

  p, pre {
    font-family: 'Nunito', 'cursive';
  }

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .barra-sup {
    background: #5269A7;
    width: 100%;
    height: 13px;
    content: "";
  }

  .header {
    padding: 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    img {
      width: 110px;
    }

    .text {
      .titulo {
        font-size: 9px;
        color: #787979;
      }

      .titulo-data {
        font-size: 9px;
        color: #A4A2A2;
      }
    }
  }
  
  .body {
    padding: 1em 2em;

    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .text {
        .titulo {
          font-size: 11px;
          color: #5269A7;
        }

        .sub-titulo {
          font-size: 9px;
          color: #A4A2A2;
        }
      }

      .numero-os {
        border-radius: 6px;
        background: #D7E1FF;
        padding: 0.3em 0.8em;
        height: 1.6em;

        .titulo {
          font-size: 7px;
          color: #5269A7;
        }
      }
    }

    .mid {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 1em;

      .colunas {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        border-radius: 6px;
        background: #5269A7;
        padding: 0.5em 2em;

        .col {

          .titulo {
            font-size: 9px !important;
            color: #ffffff !important;
          }
        }
      }
      
      .linhas {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 95%;
        border-radius: 6px;
        background: #EFF1F8;
        padding: 0.5em 3em;
        margin-top: 0.4em;
        
        .col {

          .titulo {
            font-size: 10px !important;
            color: #737373 !important;
          }
        }

        .col.ativo {
          padding: 0.2em .5em;
          background: #E4E7F1;
          border-radius: 6px;
        }
      }
    }
    
    .bottom {
      display: flex;
      flex-direction: column;
      margin-top: 1em;

      .text {
        .titulo {
          font-size: 10px;
          color: #5269A7;
        }

        .sub-titulo {
          font-size: 9px;
          color: #A4A2A2;
        }
      }

      .atividade {
        margin-top: 1em;
        padding: 0 1em;

        .titulo {
          font-size: 9px;
          color: #5269A7;
        }

        .sub-titulo {
          margin-top: 1em;
          font-size: 8px;
          color: #A4A2A2 !important;
        }
      }
    }
  }

  .footer {
    padding: 1em 2em;
    margin-top: 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .barra-assina {
      content: "";
      width: 100%;
      height: 3px;
      border-radius: 5px;
      background: #E4E7F1;
      position: absolute;
      top: 0;
    }

    .analista {
      width: 48%;
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      
      .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center; 
        
        .titulo {
          font-size: 10px !important;
          color: #787979 !important;
        }

        .sub-titulo {
          font-size: 9px !important;
          color: #909090 !important;
        }
      }
    }

    .cliente {
      width: 48%;
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      .content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        img {
          width: 80px;
        }

        .barra-verti {
          content: "";
          width: 2px;
          height: 25px;
          border-radius: 5px;
          background: #E4E7F1;
          margin-left: 0.8em;
          margin-right: 0.8em;
        }

        .text {
          
          .titulo {
            font-size: 9px !important;
            color: #787979 !important;
          }

          .sub-titulo {
            font-size: 9px !important;
            color: #909090 !important;
          }
        }
      }
    }
  }
`;